import type Embed from 'quill/blots/embed';
import type { Blot } from '../types';

const isSelectableInlineEmbed = (blot: Blot | null): blot is Embed =>
  blot?.statics?.blotName != null &&
  ['mention', 'attachment-mention', 'search-facet'].includes(
    blot.statics.blotName,
  );

export default isSelectableInlineEmbed;
